import { supabase } from "../lib/supabase";

export const sendRescheduleEmail = async ({
  appointmentId,
  newStartTime
}) => {
  try {
    const {
      data: { session }
    } = await supabase.auth.getSession();

    const response = await fetch(
      import.meta.env.VITE_BREVO_API,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${session?.access_token}`
        },
        body: JSON.stringify({
          appointmentId,
          newStartTime
        })
      }
    );

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.error ||
        result.message ||
        "Failed to send email"
      );
    }

    return result;
  } catch (error) {
    console.error("Email send error:", error);
    throw error;
  }
};